// Helpers for the Ecobalyse GTIN list (GET /ecobalyse/getAllGtin).

export const NA_STATUS = "N/A";

// The backend already nulls the reason for other statuses; keep the UI strict too.
export const naReasonFor = (gtin) =>
  gtin?.EcobalyseStatus === NA_STATUS && gtin?.ecobalyseNaReason
    ? gtin.ecobalyseNaReason
    : null;

// RFC 4180: quote every field so commas, quotes and line breaks stay in one cell.
const csvField = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;

export const toCsv = (rows) =>
  rows.map((row) => row.map(csvField).join(",")).join("\r\n");

export const GTIN_CSV_HEADER = [
  "Name",
  "Article ID",
  "Reference",
  "GTIN",
  "Project",
  "Traceability",
  "Score",
  "N/A reason",
  "Last Calculation",
  "Version",
  "Result Type",
];

export const gtinCsvRows = (gtins, formatDate) => [
  GTIN_CSV_HEADER,
  ...gtins.map((gtin) => [
    gtin.name || "",
    gtin.articleId || "",
    gtin.reference || "",
    gtin.gtin || "",
    gtin.projectName || "",
    gtin.traceabilityStatus || "",
    gtin.EcobalyseStatus || "",
    naReasonFor(gtin) || "",
    formatDate(gtin.lastEcobalyseAt),
    gtin.ecobalyseVersion || "",
    gtin.ecobalyseResultType || "",
  ]),
];
